import {
  LANG_LABELS,
  LANG_LEG_REGEX,
  LANG_SRC_REGEX,
  GEOLOC_BACK_COOKIE,
  DEFAULT_GEOZONE_LANGUAGE_CODE,
  DEFAULT_GEOZONE_CONTRIBZONE,
  DEFAULT_SELECTED_GEODATA
} from "../common/constants";

import { getCookie } from "../common/utils";
import { PosCountryLanguage } from "./service";

export const getDefaultSelectedValues = async () => {
  const selectedLang = (getCookie(GEOLOC_BACK_COOKIE) && getCookie(GEOLOC_BACK_COOKIE) !== '') ? getDefaultLang() : getLangFromURL();
  const countryFromUrl = checkGeoFromUrl();
  const selectedCountry = getCookie(GEOLOC_BACK_COOKIE)
                            || countryFromUrl
                              || DEFAULT_GEOZONE_LANGUAGE_CODE[selectedLang];
  // default Data
  const defaultCountryLang = {
    country : DEFAULT_SELECTED_GEODATA.country,
    lang: DEFAULT_SELECTED_GEODATA.lang,
    continent: DEFAULT_SELECTED_GEODATA.continent,
    selectedOption : DEFAULT_SELECTED_GEODATA.lang + '_' + DEFAULT_SELECTED_GEODATA.country,
    langLabel: DEFAULT_SELECTED_GEODATA.langLabel
  }

  try {
    // check country/lang existing on the conf from the POS HANDLER API
    const POS_SERVICE = PosCountryLanguage.getInstance();
    const isLangInCountry = await POS_SERVICE.isLangInCountry(selectedCountry, selectedLang);
    if(isLangInCountry !== null) {
      defaultCountryLang.country = selectedCountry;
      defaultCountryLang.lang = selectedLang;
      defaultCountryLang.continent = isLangInCountry.continent;
      defaultCountryLang.selectedOption =  selectedLang + '_' + selectedCountry;
      defaultCountryLang.langLabel = LANG_LABELS[selectedLang];
    } else {
      const countryFromDefaultValues = DEFAULT_GEOZONE_CONTRIBZONE[countryFromUrl] || DEFAULT_GEOZONE_LANGUAGE_CODE[getLangFromURL()];
      const isCountryLangOnConf = await POS_SERVICE.isLangInCountry(countryFromDefaultValues, getLangFromURL());
      defaultCountryLang.country = (isCountryLangOnConf && isCountryLangOnConf.country) ? isCountryLangOnConf.country : DEFAULT_GEOZONE_LANGUAGE_CODE[getLangFromURL()];
      defaultCountryLang.lang = getLangFromURL();
      defaultCountryLang.continent =  await getContinentName(defaultCountryLang.country);
      defaultCountryLang.selectedOption =  defaultCountryLang.lang + '_' + defaultCountryLang.country;
      defaultCountryLang.langLabel = LANG_LABELS[defaultCountryLang.lang];
    }
    return defaultCountryLang;
  } catch (error) {
    return defaultCountryLang;
  }

};

export const checkGeoFromUrl = (currentUrl = window.location.pathname) => {
  const supportedLang = '(ar|de|es|fr|gb|en|id|it|ja|ko|nl|pl|pt|pt-br|ru|sv|th|tr|vi|zh)';
  const regExpNewGeoloc = new RegExp('\\/([0-9a-z-]*)\\/[0-9a-z-]*\\.' + supportedLang + '\\.[a-z]{2,6}');
  const regExpCountry = new RegExp('\\/' + supportedLang + '\\/([a-z\-]*)\\/');
  const regExpCountryAem = new RegExp('\\/' + supportedLang + '\\/([a-z\-]*)\\.html');
  return (regExpNewGeoloc.exec(currentUrl) ? regExpNewGeoloc.exec(currentUrl)[1] : null)
                          || (regExpCountry.exec(currentUrl) ? regExpCountry.exec(currentUrl)[2] : null) || null
                            || (regExpCountryAem.exec(currentUrl) ? regExpCountryAem.exec(currentUrl)[2] : null) || null;
}

export const getContinentName = async (country) => {
  try {
    const POS_SERVICE = PosCountryLanguage.getInstance();
    const continentData = await POS_SERVICE.getContinentFromCountry(country);
    return continentData.continentLabel
  } catch (error) {
    throw new Error(error);
  }
};

export const getDefaultLang = () => {
  const lang =
    getCookie("userLang") ||
    getCookie("userPrefLocalization") ||
    getCookie("userLocalizationInitial") ||
    getLangFromURL();
  return lang === "gb" ? "en" : lang;
};

export const getLangFromURL = () => {
  const URL = window.location.href;
  const isSrcURL = LANG_SRC_REGEX.test(URL);
  const isLegURL = LANG_LEG_REGEX.test(URL);
  if (isSrcURL) return URL.match(LANG_SRC_REGEX).pop();
  if (isLegURL) return URL.match(LANG_LEG_REGEX).at(-2);
  return null;
};

